export default __webpack_public_path__ + "static/media/IMG_9778 copie.898e2f9f.jpg";